module.exports = __webpack_public_path__ + "img/jiayou_checked.cffb2115.png";